import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { PublishedRelease } from "../lib/api-client/changelog";
import { ReleaseNotesList } from "../components/ReleaseNotes";

export default function Changelog() {
  const [releases, setReleases] = useState<PublishedRelease[]>([]);
  const [state, setState] = useState<"loading" | "ready" | "error">("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState("loading");
    api.publishedReleases().then((response) => {
      if (active) { setReleases(response.releases); setState("ready"); }
    }).catch(() => { if (active) setState("error"); });
    return () => { active = false; };
  }, [attempt]);
  return <div className="container-x max-w-4xl pb-12 changelog-page">
    {state === "ready" ? <ReleaseNotesList releases={releases} /> : <h1 className="py-9 text-3xl font-extrabold text-navy sm:py-12 sm:text-4xl">Changelog</h1>}
    {state === "loading" && <p role="status" className="text-mut">Loading release notes…</p>}
    {state === "error" && <div role="alert" className="card p-6"><p>Could not load the release notes. Please try again.</p><button type="button" className="btn-outline mt-3" onClick={() => setAttempt((value) => value + 1)}>Retry release notes</button></div>}
    {state === "ready" && releases.length === 0 && <p className="text-mut">No release notes have been published yet.</p>}
  </div>;
}
